"use client";
import { Button } from "@/app/components/shadcn/button";
import Link from "next/link";
import useSearch from "@/app/lib/features/search/search.hook";
import PopularSearchesSkeleton from "@/app/components/elements/skeletons/PopularSearchesSkeleton";
import { trackGeneric } from "@/app/lib/tracking/interactions";

interface PopularSearchesProps {
  onClose: () => void;
}

const PopularSearches = ({ onClose }: PopularSearchesProps) => {
  const { popularSearches, isLoading } = useSearch();

  if (isLoading) return <PopularSearchesSkeleton />;
  if (!popularSearches || popularSearches.items.length === 0) return null;

  return (
    <div className="space-y-1">
      <h2 className="font-medium text-sm sm:text-base">
        {popularSearches.title}
      </h2>
      <div className="flex items-center flex-wrap gap-1.5 sm:gap-2 max-h-24 sm:max-h-32 overflow-y-auto">
        {popularSearches.items.map((search, i) => (
          <Button
            variant="outline"
            asChild
            key={i}
            size="sm"
            className="text-xs sm:text-sm h-7 sm:h-8 px-2 sm:px-3"
          >
            <Link
              href={`/aramasonucu?q=${encodeURIComponent(search.label)}`}
              onClick={() => { trackGeneric("search_popular", "click"); onClose(); }}
            >
              {search.label}
            </Link>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default PopularSearches;
